/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';

import AddIcon from '@material-ui/icons/Add';
import {
  Paper, withStyles, Grid, Button, TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TemplateSummary from './TemplateSummary';

const styles = (theme) => {
  return {
    root: {
      padding: theme.spacing(1),
      minHeight: 150,
    },
    blankTemplate: {
      width: '100%',
      minHeight: 150,
      height: '100%',
      textAlign: 'left',
      background: '#684f6c',
      opacity: 0.4,
      borderRadius: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      justifySelf: 'stretch',
      '&:hover': {
        opacity: 1.0,
        cursor: 'pointer',
      },
    },
    summary: {
      height: '100%',
    },
    deleteButton: {
      float: 'right',
      width: '100%',
    },
    addTemplate: {
      width: '100%',
      minHeight: 150,
      height: '100%',
      textAlign: 'left',
      borderRadius: 10,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      color: '#fff',
      justifySelf: 'stretch',
      padding: theme.spacing(1),
    },
  };
};

class MultiTemplateDay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adding: false,
      newTemplate: null,
    };
  }

  setAdding=() => {
    this.setState((prevState) => {
      return { adding: !prevState.adding };
    });
  }

  setNewTemplate=(value) => {
    this.setState({ newTemplate: value });
  }

  addTemplate = () => {
    this.props.addTemplate(this.state.newTemplate);
  }

  render() {
    const { templates, allTemplates } = this.props;
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <Grid container spacing={1}>
          <Grid container item xs={12} spacing={3}>
            {templates?.map((template, index) => {
              return (
                <Grid key={template._id} item xs={3}>
                  <Paper
                    onMouseEnter={() => { return this.setState({ isMouseInside: index }); }}
                    onMouseLeave={() => { return this.setState({ isMouseInside: -1 }); }}
                    className={classes.summary}
                  >
                    {this.state.isMouseInside === index
                      ? (
                        <Button
                          variant="contained"
                          color="secondary"
                          className={classes.deleteButton}
                          onClick={() => { return this.props.removeTemplate(index); }}
                        >
                          Remove?
                        </Button>
                      ) : null}
                    <TemplateSummary template={template} />
                  </Paper>
                </Grid>
              );
            })}
            {!this.state.adding
              ? (
                <Grid item xs={3} onClick={this.setAdding}>
                  <Paper className={classes.blankTemplate}>
                    <AddIcon fontSize="large" />
                  </Paper>
                </Grid>
              )
              : (
                <Grid item xs={3}>
                  <Paper className={classes.addTemplate}>
                    <Autocomplete
                      id="combo-box-demo"
                      options={allTemplates.sort((a, b) => {
                        const blocka = a.block ? a.block : 'undefined';
                        const blockb = b.block ? b.block : 'undefined';
                        if (blocka >= blockb) return 1;
                        return -1;
                      })}
                      value={this.state.newTemplate}
                      onChange={(event, newValue) => {
                        this.setNewTemplate(newValue);
                      }}
                      getOptionLabel={(option) => { return option.name; }}
                      groupBy={(option) => { return option.block || 'undefined'; }}
                      style={{ width: '100%' }}
                      renderInput={(params) => { return <TextField {...params} label="Template" variant="outlined" />; }}
                    />
                    <Button variant="contained" color="primary" onClick={this.addTemplate}>
                      Add
                    </Button>
                  </Paper>
                </Grid>
              )}
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default withStyles(styles)(MultiTemplateDay);
